import React from 'react'

class About extends React.Component { 
    constructor(props) {
        super(props);

        let pathNameArr = window.location.pathname.split('/')

        this.state = {
            currentCouncil: pathNameArr[pathNameArr.length-2]
        }
    } 
    
    render() {
        // TODO: doplnit dalsi info
        // TODO: pro ZMB-8 staticky soubor, jakmile bude finalni struktura
        let urlEndpoint = this.props.apiBaseUrl + 'dataset-' + this.state.currentCouncil + '-ZMB.json'

        return (
            <div className='sm:pt-3 md:pt-5 lg:pt-8'>
                <span className="p-3 mb-3 flex flex-column align-items-center">
                    <div style={{ margin: "5rem 2rem" }}>
                        <p className='text-900 text-center'>Vizualizace a analýzy dat z&nbsp;hlasování členů zastupitelstva města Brna byly vytvořeny v&nbsp;rámci diplomové práce na FIT VUT ve spolupráci s&nbsp;magistrátem města Brna. Aplikace je nyní v&nbsp;<span className='font-semibold'>pilotním provozu</span>, pokud narazíte na jakoukoliv nesrovnalost nebo byste rádi poskytli zpětnou vazbu k&nbsp;projektu, napište, prosím, na <a href="mailto:zaklova@vutbr.cz" className='font-semibold'>zaklova@vutbr.cz</a> a/nebo <a href="mailto:data@brno.cz" className='font-semibold'>data@brno.cz</a>.</p>
                        <div className='flex flex-column mt-5 md:flex-row justify-content-center align-items-center'>
                            <a style={{ filter:'none'}} href="https://www.fit.vut.cz/" target='_blank' rel='noopener noreferrer'><img src={ this.props.baseUrl + `loga/logo_fit.png` } alt="logo_FIT" style={{ width:'350px'}} /></a>
                            <a style={{ filter:'none'}} href="https://www.brno.cz/" target='_blank' rel='noopener noreferrer'><img src={ this.props.baseUrl + `loga/Logo_Brno_RED_CMYK.png` } alt="logo_MMB" style={{ width:'350px'}} /></a>
                        </div>
                        <p className='text-900 text-center'>
                            Jelikož projekt podporuje princip otevřených dat, je k dispozici také <a className='text-l text-primary font-semibold' href={urlEndpoint}>celá datová sada</a> z hlasování { this.state.currentCouncil }. zastupitelstva ve strojově zpracovatelném formátu.
                        </p>
                        <p className='text-center'><a className='text-7xl text-primary font-semibold' href={urlEndpoint}><i className="bi bi-filetype-json"></i></a></p>
                    </div>
                </span>
            </div>
        );
    }
}

export default About;
